import { AlertCircle } from "@untitledui/icons";
import { useEffect } from "react";
import { useRouteError } from "react-router";
import { EmptyState } from "@/components/application/empty-state/empty-state";
import { Button } from "@/components/base/buttons/button";
import { captureError } from "../lib/analytics.js";
import { ApiError } from "../lib/api.js";

export function RouteError() {
  const err = useRouteError();
  const status = err instanceof ApiError ? err.status : 0;
  // A failed request is control-api's to report; anything else broke here.
  useEffect(() => {
    if (!(err instanceof ApiError)) captureError(err);
  }, [err]);
  return (
    <EmptyState size="md" className="py-16">
      <EmptyState.Header pattern="none">
        <EmptyState.FeaturedIcon icon={AlertCircle} color="error" theme="light" />
      </EmptyState.Header>
      <EmptyState.Content>
        <EmptyState.Title>{status === 404 ? "未找到" : status === 403 ? "无权访问" : "出错了"}</EmptyState.Title>
        <EmptyState.Description>{err instanceof Error ? err.message : String(err)}</EmptyState.Description>
      </EmptyState.Content>
      <EmptyState.Footer>
        <Button color="secondary" href="/users">
          返回用户列表
        </Button>
      </EmptyState.Footer>
    </EmptyState>
  );
}
